// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../hooks/useQuoteContext'
// Component Imports
import UserRoleAndViewRow from '../rows/misc/UserRoleAndViewRow'
import SpacerThick from '../ui-helper-elements/SpacerThick'
// JS Imports
// Asset Imports

export default function UserRoleAndViewSection() {
   const state = useQuoteContext()

   if (state.user_view == 'Internal') {
      return (
         <div>
            <SpacerThick></SpacerThick>
            <UserRoleAndViewRow></UserRoleAndViewRow>
         </div>
      )
   }
   return null
}
